// extracted by mini-css-extract-plugin
module.exports = {"root":"_944f7b4b","hidden":"_27edd3e4","svg":"_c66731ea","spin":"_7cc98eee","circle":"_1406f6a7","loaderAnimation":"_d093ff14"};